import apiFetch from '../apiFetch'

export default function (subscriptionId, token, userId) {
  const userIdParam = userId ? `userId=${userId}` : ''
  return apiFetch({ endPoint: `EventSubscription/${subscriptionId}/Enable?${userIdParam}`, method: 'PUT', body: null, token: token })
}
